var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 157,
    viewBox: "0 0 156 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9850_27433)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9850_27433)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.349609,
    width: 156,
    height: 156,
    rx: 78,
    fill: "#EEEEF4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M111.845 195.124H44.9249C39.0416 195.124 34.2725 190.355 34.2725 184.471V49.299C34.2725 43.4156 39.0416 38.6465 44.9249 38.6465H111.845C117.729 38.6465 122.498 43.4156 122.498 49.299V184.471C122.498 190.354 117.729 195.124 111.845 195.124Z",
    fill: "#2626BC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9850_27433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.845 186.602H44.9249C39.0416 186.602 34.2725 181.833 34.2725 175.95V40.7775C34.2725 34.8941 39.0416 30.125 44.9249 30.125H111.845C117.729 30.125 122.498 34.8941 122.498 40.7775V175.95C122.498 181.833 117.729 186.602 111.845 186.602Z",
    fill: "#BEC8DC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.2729 45.3604H122.497V171.365H34.2729V45.3604Z",
    fill: "#E4EAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4284 91.6216H54.3394C52.3783 91.6216 50.7886 90.0319 50.7886 88.0707V71.378C50.7886 69.4169 52.3783 67.8271 54.3394 67.8271H72.4284C74.3895 67.8271 75.9792 69.4169 75.9792 71.378V88.0707C75.9792 90.0319 74.3895 91.6216 72.4284 91.6216Z",
    fill: "#D3DBEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.582 91.522H84.4927C82.5316 91.522 80.9419 89.9323 80.9419 87.9711V71.2784C80.9419 69.3172 82.5316 67.7275 84.4927 67.7275H102.582C104.543 67.7275 106.133 69.3172 106.133 71.2784V87.9711C106.133 89.9323 104.543 91.522 102.582 91.522Z",
    fill: "#D3DBEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.397 67.7275V91.5216H114.745C112.785 91.5216 111.194 89.9308 111.194 87.9708V71.2784C111.194 69.3183 112.785 67.7275 114.745 67.7275H122.397Z",
    fill: "#D3DBEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5029 52.9697H59.2676C58.2872 52.9697 57.4922 53.7648 57.4922 54.7451C57.4922 55.7255 58.2872 56.5206 59.2676 56.5206H97.5029C98.4832 56.5206 99.2783 55.7255 99.2783 54.7451C99.2783 53.7648 98.4836 52.9697 97.5029 52.9697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.165 87.8901H84.0757C82.1146 87.8901 80.5249 86.3004 80.5249 84.3393V67.6465C80.5249 65.6854 82.1146 64.0957 84.0757 64.0957H102.165C104.126 64.0957 105.716 65.6854 105.716 67.6465V84.3393C105.716 86.3004 104.126 87.8901 102.165 87.8901Z",
    fill: "#FF7EB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3889 80.4707H91.0454C90.065 80.4707 89.27 81.2657 89.27 82.2461C89.27 83.2265 90.065 84.0215 91.0454 84.0215H98.3889C99.3693 84.0215 100.164 83.2265 100.164 82.2461C100.164 81.2657 99.3693 80.4707 98.3889 80.4707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3893 74.6719H96.3721C95.3917 74.6719 94.5967 75.4669 94.5967 76.4473C94.5967 77.4277 95.3917 78.2227 96.3721 78.2227H98.3893C99.3697 78.2227 100.165 77.4277 100.165 76.4473C100.165 75.4669 99.3697 74.6719 98.3893 74.6719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4284 87.7899H54.3394C52.3783 87.7899 50.7886 86.2002 50.7886 84.2391V67.5459C50.7886 65.5848 52.3783 63.9951 54.3394 63.9951H72.4284C74.3895 63.9951 75.9792 65.5848 75.9792 67.5459V84.2387C75.9792 86.1998 74.3895 87.7899 72.4284 87.7899Z",
    fill: "#02FFB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6535 80.3701H61.3101C60.3297 80.3701 59.5347 81.1651 59.5347 82.1455C59.5347 83.1259 60.3297 83.9209 61.3101 83.9209H68.6535C69.6339 83.9209 70.429 83.1259 70.429 82.1455C70.429 81.1651 69.6339 80.3701 68.6535 80.3701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.654 74.5713H66.6367C65.6564 74.5713 64.8613 75.3663 64.8613 76.3467C64.8613 77.3271 65.6564 78.1221 66.6367 78.1221H68.654C69.6343 78.1221 70.4294 77.3271 70.4294 76.3467C70.4294 75.3663 69.6343 74.5713 68.654 74.5713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.397 63.9951V87.7892H114.745C112.785 87.7892 111.194 86.1984 111.194 84.2384V67.5459C111.194 65.5859 112.785 63.9951 114.745 63.9951H122.397Z",
    fill: "#9FB0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2729 171.366V105.768C34.2729 100.868 38.2463 96.8906 43.15 96.8906H113.62C118.523 96.8906 122.497 100.868 122.497 105.768V171.366H34.2729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5926 39.8438H72.1768C71.1964 39.8438 70.4014 39.0488 70.4014 38.0684C70.4014 37.088 71.1964 36.293 72.1768 36.293H84.5926C85.573 36.293 86.368 37.088 86.368 38.0684C86.368 39.0488 85.573 39.8438 84.5926 39.8438Z",
    fill: "#ABAFBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8767 39.8433C93.8576 39.8433 94.6528 39.0481 94.6528 38.0671C94.6528 37.0862 93.8576 36.291 92.8767 36.291C91.8958 36.291 91.1006 37.0862 91.1006 38.0671C91.1006 39.0481 91.8958 39.8433 92.8767 39.8433Z",
    fill: "#ABAFBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7834 108.363H63.44C62.4596 108.363 61.6646 109.158 61.6646 110.139C61.6646 111.119 62.4596 111.914 63.44 111.914H70.7834C71.7638 111.914 72.5588 111.119 72.5588 110.139C72.5588 109.158 71.7638 108.363 70.7834 108.363Z",
    fill: "#CCCDD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002 115.562H63.44C62.4596 115.562 61.6646 116.357 61.6646 117.337C61.6646 118.317 62.4596 119.112 63.44 119.112H107.002C107.982 119.112 108.777 118.317 108.777 117.337C108.777 116.357 107.982 115.562 107.002 115.562Z",
    fill: "#CCCDD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.148 119.112H45.9497C44.9693 119.112 44.1743 118.317 44.1743 117.337V110.139C44.1743 109.158 44.9693 108.363 45.9497 108.363H53.148C54.1283 108.363 54.9234 109.158 54.9234 110.139V117.337C54.9234 118.317 54.1283 119.112 53.148 119.112Z",
    fill: "#CCCDD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7834 130.358H63.44C62.4596 130.358 61.6646 131.153 61.6646 132.134C61.6646 133.114 62.4596 133.909 63.44 133.909H70.7834C71.7638 133.909 72.5588 133.114 72.5588 132.134C72.5588 131.153 71.7638 130.358 70.7834 130.358Z",
    fill: "#CCCDD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002 137.557H63.44C62.4596 137.557 61.6646 138.352 61.6646 139.332C61.6646 140.312 62.4596 141.107 63.44 141.107H107.002C107.982 141.107 108.777 140.312 108.777 139.332C108.777 138.352 107.982 137.557 107.002 137.557Z",
    fill: "#CCCDD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.148 141.107H45.9497C44.9693 141.107 44.1743 140.312 44.1743 139.332V132.134C44.1743 131.153 44.9693 130.358 45.9497 130.358H53.148C54.1283 130.358 54.9234 131.153 54.9234 132.134V139.332C54.9234 140.312 54.1283 141.107 53.148 141.107Z",
    fill: "#CCCDD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7834 152.354H63.44C62.4596 152.354 61.6646 153.149 61.6646 154.129C61.6646 155.109 62.4596 155.904 63.44 155.904H70.7834C71.7638 155.904 72.5588 155.109 72.5588 154.129C72.5588 153.149 71.7638 152.354 70.7834 152.354Z",
    fill: "#CCCDD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.148 163.103H45.9497C44.9693 163.103 44.1743 162.308 44.1743 161.327V154.129C44.1743 153.149 44.9693 152.354 45.9497 152.354H53.148C54.1283 152.354 54.9234 153.149 54.9234 154.129V161.327C54.9234 162.308 54.1283 163.103 53.148 163.103Z",
    fill: "#CCCDD1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.34961,
    width: 152,
    height: 152,
    rx: 76,
    stroke: "white",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9850_27433",
    x: 7.00213,
    y: 7.39973,
    width: 142.766,
    height: 211.018,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.54505
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.6352
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.525691 0 0 0 0 0.541259 0 0 0 0 0.595747 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9850_27433"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9850_27433",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9850_27433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 156,
    fill: "white",
    transform: "translate(0 0.349609)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9850_27433"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.349609,
    width: 156,
    height: 156,
    rx: 78,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileApp);
export default __webpack_public_path__ + "static/media/mobile-app.10fd489e2d45804aa85981a32cd47397.svg";
export { ForwardRef as ReactComponent };